import styled from "styled-components";
import BackgroundGrid from "../../assets/bg-grid.svg";

export const CustomizeMainWrapper = styled.div`
  background-color: var(--bg-dark-blue);
  background-image: url(${BackgroundGrid});
  background-position: center;
  background-size: cover;

  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
`;



export const EmblemsList = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  max-width: 1000px;

  @media screen and (max-width: 1024px) {
    max-width: 768px ;
  }
`;


export const EmblemsHeader = styled.div`
  background-color: var(--bg-light-blue);
  border-top-left-radius: 10px;
  padding: 40px 0px 40px 100px;

  border-right: 1px solid var(--highlight);
  border-bottom: 1px solid var(--highlight);
`;

export const EmblemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  margin-top: 30px;
`;

export const ColorsWrapper = styled.div`
  background-color: var(--bg-light-blue);
  padding: 50px 150px 40px 100px;

  display: flex;
  flex-direction: column;
  gap: 5px;

  flex: 1;

  position: relative;

  &:before {
    content: "";
    background-color: var(--highlight);
    width: 100%;
    height: 1px;
    top: 5px;
    left: 0;
    position: absolute;
  }

  &:after {
    content: "";
    background-color: var(--highlight);
    height: 100%;
    width: 1px;
    top: 5px;
    right: 0px;
    position: absolute;
    
  }
`;

export const Colors = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  padding-top: 30px;
`;

export const EmblemsWrapper = styled.div`
  
  height: calc(100vh - 70px); // Adjust if your header is taller
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;

  margin-top: 0; // no margin to avoid pushing down

  @media (max-height: 900px) {
    position:relative;
    top: -20px;
  }

  @media (max-height: 800px) {
    position:relative;
    top: -20px;
  }

  @media (max-width: 1024px) {
    top : 0px;  }

`;


export const Input = styled.input`
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid var(--text-light);

  color: var(--highlight);

  font-family: "'Source Serif 4'";
  font-weight: 700;
  line-height: 40px;
  font-size: 30px;

  &:focus {
    outline: none;
  }
`;

export const SideContainer = styled.div`
  background-color: var(--bg-light-blue);
  border-top-right-radius: 10px;
  width: 350px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  padding-top: 100px;

  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 0;
    height: 100%;
    width: 1px;
    background-color: var(--highlight);
  }

  @media (min-width: 2559px) {
    // margin-top: 200px;
  }

  @media (max-height: 900px) {
    height : 100%;
  }

  @media (max-height: 800px) {
    height : 100%;
  }
`;

export const ChosenEmblemContainer = styled.div`
  background-color: #fffbec;
  height: 343px;
  width: 211px;
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChosenEmblem = styled.img`
  width: ${(props) => (props.colored ? "180px" : "200px")};
  height: ${(props) => (props.colored ? "180px" : "200px")};
  object-fit: contain;
  background-color: transparent;
  transition: all 0.3s ease;
`;


export const ModalButton = styled.button`
  font-family: "Manrope";
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: var(--highlight);
  text-decoration: underline;
  cursor: pointer;
  background-color: transparent;
  border: none;
  text-align: left;
  margin-top: 5px;
`;
